import { create } from "zustand";
import axios from "axios";
// import { LogoutIcon } from "@heroicons/react/outline";

// const domain = "http://localhost:4000";
const domain = "https://backend.traderockfx.com";
// const domain = "https://manzo-travels-be.vercel.app";
// const domain = "https://manzo-travels-be.onrender.com";
// const domain = "https://backend.manzotravels.com";
axios.defaults.withCredentials = true;
export const useAuthStore = create((set) => ({
  isLoggedIn: localStorage.getItem("isLoggedIn") === true,
  user: [],
  setIsLoggedIn: (bool) => {
    set({ isLoggedIn: bool });

    localStorage.setItem("isLoggedIn", bool.toString());
  },
  setUser: (obj) => set({ user: obj }),
  loader: false,

  setLoader: (loader) => set({ loader }),

  registration: async (formData) => {
    try {
      const res = await axios.post(`${domain}/api/v1/user/signup`, formData);
      return res?.data;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  login: async (formData) => {
    try {
      const res = await axios.post(`${domain}/api/v1/user/login`, formData);
      return res?.data;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  authPrivateDataUrl: async () => {
    try {
      const res = await axios.get(`${domain}/api/v1/user/private_data`, {
        withCredentials: true,
      });

      if (res) {
        const data = await res?.data;
        // console.log(data);
        set({
          user: data?.user,
        });
        localStorage.setItem("isLoggedIn", "true");
        set({
          setIsLoggedIn: localStorage.getItem("isLoggedIn") === "true",
        });
      }
    } catch (err) {
      localStorage.setItem("isLoggedIn", "false");
      console.log(err, err?.response?.data);
    }
  },
  createInvestmentPlan: async (formData) => {
    try {
      //   console.log(formData);
      const res = await axios.post(
        `${domain}/api/v1/investment_plan/craete`,
        formData
      );
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  getAllInvestmentPlans: async () => {
    try {
      const res = await axios.get(`${domain}/api/v1/investment_plan/get_all`);
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  getAllUser: async () => {
    try {
      const res = await axios.get(`${domain}/api/v1/user/get_all`);
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  investmentPlanUpdate: async (formData) => {
    try {
      const res = await axios.post(
        `${domain}/api/v1/investment_plan/update`,
        formData
      );
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  userUpdate: async (formData) => {
    try {
      const res = await axios.post(`${domain}/api/v1/user/update`, formData);
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  getInvestmentPlans: async (id) => {
    try {
      const res = await axios.get(`${domain}/api/v1/investment_plan/${id}`);
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  updateAccount: async (formData) => {
    try {
      const res = await axios.post(
        `${domain}/api/v1/accountsNumber/update`,
        formData
      );
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  getAccount: async () => {
    try {
      const res = await axios.get(
        `${domain}/api/v1/accountsNumber/67d9750411dffc8261e2dc7f`
      );
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  logout: async () => {
    try {
      const res = await axios.get(`${domain}/api/v1/user/logout`, {
        withCredentials: true,
      });
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
  getReferral: async (referralCode) => {
    try {
      const res = await axios.get(`${domain}/api/v1/referral/${referralCode}`);
      return res;
    } catch (err) {
      console.log(err, err?.response?.data);
      return { err: err?.response?.data };
    }
  },
}));
